import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isLocked: boolean;
  onChange(isLocked: boolean): void;
  disabled: boolean;
};

export const LockSetting: React.FC<Props> = ({ isLocked, onChange, disabled }: Props) => {
  const { t } = useTranslation();
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div>
      <p className="pb-1">{t('canvas.viewModelSetting.lockDescription')}</p>
      <div className="flex items-center p-2 hover:bg-gray-200">
        <label className="flex grow cursor-pointer flex-row items-center">
          <input
            type="checkbox"
            className="form-checkbox size-4 cursor-pointer border-brand"
            checked={isLocked}
            onChange={handleChange}
            disabled={disabled}
          />
          <p className="grow px-2">{t('canvas.viewModelSetting.lockCheckbox')}</p>
        </label>
      </div>
    </div>
  );
};
